// CSV 파일을 이메일로 보내기 위한 컨트롤러
// prompt로 이메일 주소를 입력받아 POST 요청
//
// <a href="/send_csv"
//    data-controller="components--send-csv-email"
//    data-components--send-csv-email-default-email-value="user@example.com"
//    data-action="click->components--send-csv-email#promptAndSubmit">
//   Email로 보내기
// </a>
import { Controller } from "@hotwired/stimulus";
import api from "@/utils/api";

export default class extends Controller {
  static values = {
    defaultEmail: String,
  };

  promptAndSubmit(event) {
    event.preventDefault();

    const defaultEmail = this.defaultEmailValue || "";
    const email = prompt(
      "CSV 파일을 받을 이메일 주소를 입력해 주세요:",
      defaultEmail
    );

    if (email === null) {
      // 취소 버튼 클릭
      return;
    }

    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      alert("이메일 주소를 입력해 주세요.");
      return;
    }

    if (!this.isValidEmail(trimmedEmail)) {
      alert("올바른 이메일 주소 형식이 아닙니다.");
      return;
    }

    // 현재 링크의 URL에 receiver_email 파라미터를 추가하여 POST 요청
    const url = new URL(this.element.href, window.location.origin);
    const params = Object.fromEntries(url.searchParams.entries());
    params.receiver_email = trimmedEmail;

    api.post(url.pathname, params)
      .then(() => {
        alert("CSV 파일 전송이 시작되었습니다. 잠시 뒤에 이메일 수신함을 확인해 주세요.");
      })
      .catch((error) => {
        console.error("CSV 전송 요청 실패:", error);
        const message = error.response?.data?.error || "CSV 전송 요청에 실패했습니다. 다시 시도해 주세요.";
        alert(message);
        if (error.response?.data?.redirect_url) {
          window.location.href = error.response.data.redirect_url;
        }
      });
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
}
